import {
  Box,
  Button,
  FormControl,
  FormGroup,
  Input,
  InputLabel,
  Typography,
} from "@mui/material";
import "./MyOrders.css";
import { useTranslation } from "react-i18next";
import OrderGrid from "./OrderGrid/OrderGrid";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { addAddress } from "../../redux/slices/addressSlice";

const MyOrders = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const address = useSelector((state) => state.address.address);
  const [phone, setPhone] = useState();

  const handleSubmit = () => {
    dispatch(
      addAddress({
        address: {
          fullName: "",
          phone: phone,
          address: "",
        },
      }),
    );
  };

  return (
    <Box sx={{ padding: "15px", textAlign: "left" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "#abababcc",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            padding: "10px 0",
          }}
        >
          {t("my-orders.header")}
        </Typography>
        <Typography sx={{ padding: "5px" }}>{t("my-orders.note")}</Typography>
      </Box>
      {!address?.phone && (
        <Box sx={{ maxWidth: "400px" }}>
          <FormGroup>
            <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
              <InputLabel htmlFor="phone">{t("my-orders.phone")} *</InputLabel>
              <Input
                required
                id="phone"
                value={phone}
                sx={{ width: "100%" }}
                onChange={(e) => setPhone(e.target.value)}
              />
            </FormControl>
            <Button
              disabled={!phone}
              variant="contained"
              onClick={handleSubmit}
            >
              {t("my-orders.save")}
            </Button>
          </FormGroup>
        </Box>
      )}
      {address?.phone && <OrderGrid></OrderGrid>}
    </Box>
  );
};

export default MyOrders;
